import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export default class LaravelEcho {
  constructor(appId, key, options) {
    this.appId = appId
    this.key = key
    this.options = options
    this.client = new Pusher(key, {
      wsHost: options.host,
      wsPort: options.port,
      forceTLS: options.port === 443,
      encrypted: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
    })

    this.echo = new Echo({
      client: this.client,
      broadcaster: 'pusher',
      key: key,
      wsHost: options.host,
      wsPort: options.port,
      forceTLS: false,
      encrypted: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
    })
  }

  getEcho() {
    return this.echo
  }

  getPusher() {
    return this.client
  }
}
